import * as React from 'react';

import DateFnsUtils from '@date-io/date-fns';
import {
  DateTimePicker as MuiDateTimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';

import { IProps } from './interfaces';

import styles from './DateTimePicker.module.styl';

class DateTimePicker extends React.Component<IProps> {
  public render() {
    const { input, meta, title, disabled } = this.props;

    const control = (
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <MuiDateTimePicker
          inputVariant="outlined"
          value={input.value || null}
          onChange={this.handleChange}
          label={title}
          ampm={false}
          error={meta.touched && meta.error}
          showTodayButton={true}
          disabled={disabled}
          format="dd/MM/yyyy HH:mm"
        />
      </MuiPickersUtilsProvider>
    );

    return (
      <div className={styles.root}>
        {control}
        {meta.touched && meta.error && (
          <span className={styles.error}>{meta.error}</span>
        )}
      </div>
    );
  }

  private readonly handleChange = (value: any) => {
    const {
      input: { onChange },
    } = this.props;

    onChange(value.toISOString());
  };
}

export default DateTimePicker;
